import { useEffect } from 'react';
import ReactDOM from 'react-dom';

/**
 * Bandeau d'environnement — affiché en haut de l'écran hors production pour
 * éviter toute confusion entre staging/dev et la prod (PII réelles en staging).
 * Détection 100 % runtime par hostname : aucun rebuild ni variable d'env requis.
 */
function detectEnv() {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
    return { label: 'DEV', show: true };
  }
  if (host.includes('staging')) {
    return { label: 'STAGING', show: true };
  }
  return { label: 'PROD', show: false };
}

const BANNER_HEIGHT = 22;

export default function EnvBanner() {
  const env = detectEnv();

  // Décale tout le contenu vers le bas pour que le bandeau ne masque pas le
  // header sticky de l'app. Nettoyé si le bandeau disparaît.
  useEffect(() => {
    if (!env.show) return undefined;
    const prev = document.body.style.paddingTop;
    document.body.style.paddingTop = `${BANNER_HEIGHT}px`;
    return () => {
      document.body.style.paddingTop = prev;
    };
  }, [env.show]);

  if (!env.show) return null;

  return ReactDOM.createPortal(
    <div
      role="status"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        height: BANNER_HEIGHT,
        lineHeight: `${BANNER_HEIGHT}px`,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 2,
        color: '#1a1a1a',
        background: 'var(--warning)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        pointerEvents: 'none',
      }}
    >
      {env.label}
    </div>,
    document.body,
  );
}
